// extracted by css-extract-rspack-plugin
export default {"promoStrip":"PromoStrip-module__promoStrip___kqi7F","text":"PromoStrip-module__text___fugbT"};